import { Suspense, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import useAppState from 'context/useAppState';

// Guard khusus user eksternal: wajib login DAN hanya user dengan is_external_flag === true.
export default function ExternalRoute() {
  const { isAuthenticated, data } = useAppState((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();

  const isExternal = data?.user?.is_external_flag === true;

  useEffect(() => {
    // Belum login → arahkan ke login dengan menyimpan tujuan
    if (!isAuthenticated) {
      const redirectLink = encodeURIComponent(location.pathname + location.search);
      navigate(`/login?continue=${redirectLink}`, { replace: true, state: location });
      return;
    }

    // Sudah login tapi bukan user eksternal → tolak akses
    if (!isExternal) {
      navigate('/no-access', { replace: true });
    }
  }, [navigate, location, isAuthenticated, isExternal]);

  // Hindari render konten sebelum verifikasi selesai
  if (!isAuthenticated || !isExternal) return null;

  return (
    <Suspense fallback="...">
      <Outlet />
    </Suspense>
  );
}
